const MOVIES_FETCH_REQUEST = "MOVIES_FETCH_REQUEST";
const MOVIES_FETCH_ERROR = "MOVIES_FETCH_ERROR";
const MOVIES_FETCH_SUCCESS = "MOVIES_FETCH_SUCCESS";
const SELECTED_MOVIE = "SELECTED_MOVIE";
export {
  MOVIES_FETCH_REQUEST,
  MOVIES_FETCH_ERROR,
  MOVIES_FETCH_SUCCESS,
  SELECTED_MOVIE,
};
